//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import FroalaNotifications from "@/components/DocumentEditor/Froala/FroalaNotifications.vue";
import { formatDataModelVar } from "@/components/DocumentEditor/Froala/DatamodelTable";

export default {
    components: {
        FroalaNotifications,
        AQButton,
        variablesCard: () => import(/* webpackChunkName: "variablesCard" */ "@/components/Diagrams/variables-card.vue")
    },
    props: {
        uuid: {
            required: true,
            type: String
        },
        elementIndex: {
            type: Number
        },
        readonly: {
            type: Boolean
        },
        value: String,
        dataContent: Object,
        selectedTab: String
    },
    data() {
        return {
            showSave: false,
            smsSubject: null,
            showVariables: false,
            activeTab: "",
            msgBodyType: this.$t("dataTable.btnData"),
            selected: {
                name: "",
                id: "",
                processDefinitionId: "",
                template: ""
            }
        };
    },
    computed: {
        ...mapGetters("diagrams", ["selectedPluginConfigData"]),
        computedValue: {
            get() {
                return this.smsSubject ? this.smsSubject : this.value || "";
            },
            set(v) {
                this.smsSubject = v;
            }
        }
    },
    watch: {
        computedValue() {
            this.showSave = true;
        },
        dataContent: {
            handler(newValue) {
                if (newValue) {
                    this.computedValue = newValue.smsBoby;
                    this.selected.template = newValue.smsBoby;
                }
            },
            immediate: true
        }
    },
    methods: {
        onFieldClicked(data) {
            const newElemment = formatDataModelVar({ formatted: data.field.variable, model: data.field.name, type: data.field.type });
            this.$root.$emit("sendElToInsert", newElemment);
        },
        activateVariables(itemValue) {
            if (typeof itemValue === "string") { this.msgBodyType = itemValue; }
            this.showVariables = !this.showVariables;
            this.activeTab = this.msgBodyType === "VAR" ? "variables" : "dataModel";
        }
    }
};
